import startCase from 'lodash.startcase';
const getStackState = (value) => {
    if (!value)
        return 'Empty';
    if (Array.isArray(value)) {
        const [first, second] = value;
        if (!first && !second)
            return 'Empty';
        if (!first && second)
            return 'FirstStack';
        if (first && second)
            return 'TopStack';
    }
    return 'FirstStack';
};
export const genPath = (coordinates) => {
    const { x = 0, y = 0, width = 0, height = 0, barBorderRadius: borderRadius = 2, value } = coordinates;
    const stackState = getStackState(value);
    if (stackState === 'Empty')
        return;
    if (stackState === 'FirstStack') {
        return `
    M ${x} ${y + borderRadius}
    a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},-${borderRadius}
    h ${width - borderRadius * 2}
    a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},${borderRadius}
    v ${height - borderRadius * 2}
    a${borderRadius},${borderRadius} 0 0 1 -${borderRadius},${borderRadius}
    h -${width - borderRadius * 2}
    a${borderRadius},${borderRadius} 0 0 1 -${borderRadius},-${borderRadius}
    Z
    `;
    }
    if (stackState === 'TopStack') {
        return `
  M ${x} ${y + borderRadius}
  a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},-${borderRadius}
  h ${width - borderRadius * 2}
  a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},${borderRadius}
  v ${height}
  a${borderRadius},${borderRadius} 1 0 0 -${borderRadius},-${borderRadius}
  h -${width - borderRadius * 2}
  a${borderRadius},${borderRadius} 1 0 0 -${borderRadius},${borderRadius}
  Z
  `;
    }
};
export const tooltipFormatter = (value, name) => [value, startCase(name)];
